module.exports = __webpack_public_path__ + "img/18600.93f1c36d.jpg";